export const ROOT_LOADED_PROGRESS = 5;